import axios from 'axios';

const BaseURL = 'https://woodshopboardapi.caddiesoft.com';

const APIS = {
    Department: '/department',
    Salestat: '/salestat'
};

export default async function Request(path, searchParams) {
    var encodedSearchParams = '';

    try {
        if (searchParams) {
            for (const key in searchParams) {
                encodedSearchParams += `&${key}=${searchParams[key]}`
            }
        }

        if (encodedSearchParams.length > 0) encodedSearchParams = '?' + encodedSearchParams.substring(1, encodedSearchParams.length);

        const completeURL = `${BaseURL}${path}${encodedSearchParams}`;

        // Debug
        console.log(`Request: ${completeURL}`);

        return await (await axios.get(completeURL)).data;
    } catch(err) {
        console.error(err)
    }
}

export { APIS, BaseURL }


// WEBPACK FOOTER //
// ./src/js/Request.js